<div class="jolojo-html-plugin">
  {@html fields.content}
</div>

<script>
  export let fields = {}
</script>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>